import JsBarcode from 'jsbarcode'

import { Symbology } from '../document'

/**
 * A barcode as an SVG string for HTML / A4 / screen. JsBarcode encodes into a plain object (no DOM), and the bars are
 * drawn here, so the same code runs in the browser, in tests and during server-side rendering.
 */
export const barcodeSvg = (value: string, symbology: Symbology, opts: { heightMm?: number; showText?: boolean; moduleMm?: number } = {}) => {
  const target: { encodings?: { data: string; text?: string }[] } = {}
  JsBarcode(target, value, { format: symbology === 'ean13' ? 'EAN13' : 'CODE128', flat: true, displayValue: false })
  const bits = (target.encodings ?? []).map((e) => e.data).join('')
  if (!bits) throw new Error(`Cannot encode ${value} as ${symbology}`)
  const module = opts.moduleMm ?? 0.33
  const barH = opts.heightMm ?? 12
  const textH = opts.showText === false ? 0 : 3.5
  const quiet = 10 * module
  const width = bits.length * module + quiet * 2
  let rects = ''
  for (let i = 0; i < bits.length; ) {
    if (bits[i] !== '1') {
      i++
      continue
    }
    let run = 1
    while (bits[i + run] === '1') run++
    rects += `<rect x="${(quiet + i * module).toFixed(3)}" y="0" width="${(run * module).toFixed(3)}" height="${barH}"/>`
    i += run
  }
  const label = textH
    ? `<text x="${(width / 2).toFixed(2)}" y="${(barH + 3).toFixed(2)}" font-size="3" text-anchor="middle" font-family="monospace">${escapeXml(value)}</text>`
    : ''
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${width.toFixed(2)} ${barH + textH}" width="${width.toFixed(2)}mm" height="${barH + textH}mm" fill="#000">${rects}${label}</svg>`
}

export const escapeXml = (s: string) =>
  s.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c] as string)
